import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { ApiConfigService } from "./shared-services/api-config.service";
import { AuthServiceService } from "./shared-services/auth-service.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { GlobalDataService } from "./shared-services/global-data.service";
import { AuthGuardService } from "./guards/auth-guard.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from '@angular/forms';
import { RemoteComponent } from './layout/remote/remote.component';
import { LandingPageComponent } from './layout/remote/landing-page/landing-page.component';
import { TopNavigationComponent } from './layout/remote/components/top-navigation/top-navigation.component';
import { LoginWindowComponent } from './layout/remote/components/login-window/login-window.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faSun } from '@fortawesome/free-solid-svg-icons';
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { faCompressAlt } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons';
import { MapPageComponent } from './layout/remote/map-page/map-page.component';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faHeart } from '@fortawesome/free-regular-svg-icons/faHeart';
import { faHeart as HeartSolid } from '@fortawesome/free-solid-svg-icons/faHeart';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SignupWindowComponent } from './layout/remote/components/signup-window/signup-window.component';
import { SocialLoginComponent } from './layout/remote/components/social-login/social-login.component';
import { SiteDetailComponent } from './layout/remote/site-detail/site-detail.component';
import { AudioComponent } from './layout/remote/components/audio/audio.component';
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons/faVolumeUp";
import { faVolumeMute } from "@fortawesome/free-solid-svg-icons/faVolumeMute";
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt";
import { SecurePipe } from "./layout/remote/pipes/secure.pipe";
import { SimpleMapComponent } from './layout/remote/components/simple-map/simple-map.component';
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faHelicopter } from '@fortawesome/free-solid-svg-icons/faHelicopter';
import { MonumentDetailComponent } from './layout/remote/monument-detail/monument-detail.component';
import { SitePacketsComponent } from './layout/remote/components/site-packets/site-packets.component';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { BuyPageComponent } from './layout/remote/buy-page/buy-page.component';
import { UserBasicInfoComponent } from './layout/remote/components/profile/user-basic-info/user-basic-info.component';
import { UserBillingInfoComponent } from './layout/remote/components/profile/user-billing-info/user-billing-info.component';
import { ImagePopupComponent } from './layout/remote/components/image-popup/image-popup.component';
import { faImages } from '@fortawesome/free-regular-svg-icons';
import { ModelContainerComponent } from './layout/remote/components/model-container/model-container.component';
import { ProfilePageComponent } from './layout/remote/profile-page/profile-page.component';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons/faTruckMoving';
import { UserPasswordComponent } from './layout/remote/components/profile/user-password/user-password.component';
import { faUnlock } from '@fortawesome/free-solid-svg-icons/faUnlock';
import { PriceListComponent } from './layout/remote/price-list/price-list.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TermsPolicyComponent } from './layout/remote/components/terms-policy/terms-policy.component';
import { AboutPageComponent } from './layout/remote/about-page/about-page.component';
import { SearchResultsComponent } from './layout/remote/search-results/search-results.component';
import { JoinMeetingComponent } from './layout/virtualTour/join-meeting/join-meeting.component';
import { MeetingRoomComponent } from './layout/virtualTour/meeting-room/meeting-room.component';
import { MeetingSpotComponent } from './layout/virtualTour/meeting-spot/meeting-spot.component';
import { OnlineIndicatorComponent } from './layout/virtualTour/components/online-indicator/online-indicator.component';
import { AgoraConfig } from 'ngx-agora';
import { NgxAgoraModule } from 'ngx-agora';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { TimezoneConverterComponent } from './layout/virtualTour/components/timezone-converter/timezone-converter.component';
import { faHandPaper } from '@fortawesome/free-solid-svg-icons/faHandPaper';
import { faMousePointer } from '@fortawesome/free-solid-svg-icons';
import { faMapPin } from '@fortawesome/free-solid-svg-icons';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SharedViewComponent } from './layout/virtualTour/components/shared-view/shared-view.component';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { faDirections } from '@fortawesome/free-solid-svg-icons/faDirections';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons/faCommentDots';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faLandmark } from '@fortawesome/free-solid-svg-icons/faLandmark';
import { faGlobeEurope } from '@fortawesome/free-solid-svg-icons/faGlobeEurope';
import { MeetingIntroComponent } from './layout/virtualTour/components/meeting-intro/meeting-intro.component';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/faQuestionCircle';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const agoraConfig: AgoraConfig = {
    AppID: '5a3f5b28fb3642668022ce476f1f3996',
};

@NgModule({
    declarations: [
        AppComponent,
        AdminComponent,
        AuthComponent,
        BreadcrumbsComponent,
        RemoteComponent,
        LandingPageComponent,
        MapPageComponent,
        TopNavigationComponent,
        LoginWindowComponent,
        SignupWindowComponent,
        SocialLoginComponent,
        SiteDetailComponent,
        AudioComponent,
        SecurePipe,
        SimpleMapComponent,
        MonumentDetailComponent,
        SitePacketsComponent,
        BuyPageComponent,
        UserBasicInfoComponent,
        UserBillingInfoComponent,
        ImagePopupComponent,
        ModelContainerComponent,
        ProfilePageComponent,
        UserPasswordComponent,
        PriceListComponent,
        TermsPolicyComponent,
        AboutPageComponent,
        SearchResultsComponent,
        JoinMeetingComponent,
        MeetingRoomComponent,
        MeetingSpotComponent,
        OnlineIndicatorComponent,
        TimezoneConverterComponent,
        SharedViewComponent,
        MeetingIntroComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        NgSelectModule,
        NgbCollapseModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        FontAwesomeModule,
        ReactiveFormsModule,
        NgxSliderModule,
        NgxAgoraModule.forRoot(agoraConfig),
        NgxDropzoneModule,
        /* NgxMapboxGLModule.withConfig({
             accessToken: 'pk.eyJ1IjoiY3VsdHVyZWFwcCIsImEiOiJja2dwbGY0ZHowYjdmMnd0ZDQ0ZWRyZDY4In0.3euKoCD40AHQsnmUIWg32Q', // Optional, can also be set per map (accessToken input of mgl-map)
             geocoderAccessToken: 'TOKEN' // Optional, specify if different from the map access token, can also be set per mgl-geocoder (accessToken input of mgl-geocoder)
         }),*/
    ],
    providers: [MenuItems, ApiConfigService, GlobalDataService, AuthGuardService, AuthServiceService],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private library: FaIconLibrary) {
        library.addIcons(faPlus)
        library.addIcons(faChevronLeft);
        library.addIcons(faChevronRight);
        library.addIcons(faChevronDown);
        library.addIcons(faChevronUp);
        library.addIcons(faHeart);
        library.addIcons(HeartSolid);
        library.addIcons(faVolumeUp);
        library.addIcons(faVolumeMute);
        library.addIcons(faMapMarkedAlt);
        library.addIcons(faTimes);
        library.addIcons(faInfoCircle);
        library.addIcons(faHelicopter);
        library.addIcons(faCheck);
        library.addIcons(faCheckCircle);
        library.addIcons(faImages);
        library.addIcons(faTrash);
        library.addIcons(faUser);
        library.addIcons(faLock);
        library.addIcons(faEnvelope);
        library.addIcons(faShoppingCart);
        library.addIcons(faTruckMoving);
        library.addIcons(faLock);
        library.addIcons(faUnlock);
        library.addIcons(faSun);
        library.addIcons(faMoon);
        library.addIcons(faExpand);
        library.addIcons(faCompressAlt);
        library.addIcons(faWindowClose);
        library.addIcons(faLayerGroup);
        library.addIcons(faMapMarkerAlt);
        library.addIcons(faMobileAlt);
        library.addIcons(faPhoneAlt);
        library.addIcons(faEnvelope);
        library.addIcons(faSearch)
        library.addIcons(faHandPaper)
        library.addIcons(faPhone)
        library.addIcons(faVideo)
        library.addIcons(faCog)
        library.addIcons(faMicrophone)
        library.addIcons(faFolder)
        library.addIcons(faShareSquare)
        library.addIcons(faMousePointer)
        library.addIcons(faMapPin)
        library.addIcons(faArrowDown)
        library.addIcons(faCircle)
        library.addIcons(faTags)
        library.addIcons(faImage)
        library.addIcons(faArrowLeft);
        library.addIcons(faSyncAlt);
        library.addIcons(faDirections);
        library.addIcons(faCalendarAlt);
        library.addIcons(faEdit);
        library.addIcons(faList);
        library.addIcons(faCommentDots);
        library.addIcons(faUsers);
        library.addIcons(faLandmark);
        library.addIcons(faGlobeEurope);
        library.addIcons(faQuestionCircle);
    }
}
